import { clevertapEvent } from 'utils/clevertap';

// Affiliate Partner - Navigate
export const affiliateNavigationEvents = {
  /**
     Navigate - 1
     When user landed at external community page
  */
  externalCommunityViewed: () => clevertapEvent('External Community Viewed'),
  /**
     Navigate - 2
     when user landed on detail Confirmed Code Community pop-up
  */
  confirmedCodeCommunityViewed: (code: string) =>
    clevertapEvent('Confirmed Code Community Viewed', {
      affiliate_code: code,
    }),
  /**
     Navigate - 3
     when user landed on Success Activated Code Community page
  */
  activatedSuccessCodeCommunityViewed: (code: string) =>
    clevertapEvent('Success Activated Code Community Viewed', {
      affiliate_code: code,
    }),
  /**
     Navigate - 4 & 5
     when user (member of community) landed on External Community Page
  */
  membersExternalCommunityViewed: (isExitEnabled: boolean) =>
    clevertapEvent('Members External Community Viewed', {
      is_exit: isExitEnabled ? 'True' : 'False', // is exit enabled
    }),
  /**
     Navigate - 6
     when user landed on Exit External Community pop-up
  */
  exitExternalCommunityViewed: () =>
    clevertapEvent('Exit External Community Viewed'),
};
// Affiliate Partner - Action
export const affiliateActions = {
  /**
     Action - 1
     user click External Community on Settings Menu
  */
  externalCommunitySelected: () =>
    clevertapEvent('Affiliate Partner Action', {
      Action: 'External Community Selected',
    }),
  /**
     Action - 3
     user click Lanjut after input the code community to activate
  */
  activatedCodeSelected: (code: string) =>
    clevertapEvent('Affiliate Partner Action', {
      Action: 'Activated Code Selected',
      affiliate_code: code,
    }),
  /**
     Action - 4
     user click Batal on pop-up Confirmation Code Community
  */
  activatedCodeCanceled: (code: string) =>
    clevertapEvent('Affiliate Partner Action', {
      Action: 'Activated Code Canceled',
      affiliate_code: code,
    }),
  /**
     Action - 5
     user click Konfirmasi on pop-up Confirmation Code Community
  */
  activatedCodeConfirmed: (code: string) =>
    clevertapEvent('Affiliate Partner Action', {
      Action: 'Activated Code Confirmed',
      affiliate_code: code,
    }),
  /**
     Action - 6
     user click Selesai on Success Activated Code Community page
  */
  activatedCodeSuccessSelected: (code: string) =>
    clevertapEvent('Affiliate Partner Action', {
      Action: 'Activated Code Success Selected',
      affiliate_code: code,
    }),
  /**
     Action - 7
     user click Keluar Komunitas on External Community Page
  */
  exitCommunitySelected: () =>
    clevertapEvent('Affiliate Partner Action', {
      Action: 'Exit Community Selected',
    }),
  /**
     Action - 8
     user click Batal on External Community Page
  */
  exitCommunityCanceled: () =>
    clevertapEvent('Affiliate Partner Action', {
      Action: 'Exit Community Canceled',
    }),
  /**
     Action - 9
     user click Keluar on External Community Page
  */
  exitCommunityConfirmed: () =>
    clevertapEvent('Affiliate Partner Action', {
      Action: 'Exit Community Confirmed',
    }),
};
